/**
 * Content type enumeration.
 * Defines all possible content types in the application, including events, corners, addons, channels, etc.
 */

enum Content {
  ADDON = 'addon',
  APP = 'app',
  AVOD = 'avod',
  BACK_DOOR = 'backDoor',
  CHANNEL = 'channel',
  CHANNEL_GUIDE = 'channelGuide',
  CORNER = 'corner',
  EPG_EVENT = 'EpgEvent',
  EVENT = 'event',
  GENRE = 'genre',
  FAST_EVENT = 'fastEvent',
  IA_CORNER = 'iacorner',
  IMAGE_ADS = 'image_ads',
  MEDIA_PRODUCTION = 'MediaProduction',
  RECORDING_EVENT = 'recordingEvent',
  SEASON = 'season',
  SERIES = 'serie',
  SETTING = 'setting',
  SHOW = 'show',
  SVOD = 'svod',
  VIDEO_ADS = 'video_ads',
  VIEW_MORE = 'viewMore',
}

enum Type {
  SHOW = 0,
  SEASON = 1,
  SERIES = 6,
}

export default Content;
export { Type };
